import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import {
  getEvidenceCountPMKB,
  gettopEvidencePMKB,
  getWeillCornell,
} from "../../../../state/selectors/CancerCurated.selectors";
import { TIER_TO_PATHOGENICITY } from "./constants";
import { calcColor } from "./helpers";
import { DEFAULT_COLOR } from "../../../../common/helpers/helpers";

const PMKBCard = ({ card, evidenceCount, topEvidence, pmkbData }) => {
  const color = calcColor(topEvidence) || DEFAULT_COLOR;
  return (
    <CardWrapper {...card} isDisabled={!pmkbData} color={color}>
      {pmkbData ? (
        <>
          <div className="tw-flex">
            <div>
              {topEvidence ? (
                <b
                  data-testid="pmkb-tier"
                  className="tw-mr-2"
                  style={{ color }}
                >
                  {TIER_TO_PATHOGENICITY[topEvidence.tier]}
                </b>
              ) : null}
            </div>
            <div>
              {evidenceCount ? (
                <div>
                  Evidence:{" "}
                  <b data-testid="pmkb-evidence-count">{evidenceCount}</b>
                </div>
              ) : null}
            </div>
          </div>
          <b className="tw-capitalize" data-testid="pmkb-tissue">
            {topEvidence?.tumour_types?.[0]}
          </b>
        </>
      ) : null}
    </CardWrapper>
  );
};

PMKBCard.propTypes = {
  evidenceCount: PropTypes.number,
  topEvidence: PropTypes.shape({
    tier: PropTypes.number,
    definition: PropTypes.arrayOf(PropTypes.string),
    interpretations: PropTypes.string,
    tissues: PropTypes.arrayOf(PropTypes.string),
    tumour_types: PropTypes.arrayOf(PropTypes.string),
    disease_or_trait: PropTypes.node,
    pub_med_references: PropTypes.arrayOf(PropTypes.number),
    variants: PropTypes.arrayOf(
      PropTypes.shape({
        variants: PropTypes.arrayOf(PropTypes.string),
        type: PropTypes.string,
        definition: PropTypes.string,
        gene_id: PropTypes.number,
      })
    ),
  }),
  pmkbData: PropTypes.arrayOf(
    PropTypes.shape({
      version: PropTypes.string,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          tier: PropTypes.number,
          definition: PropTypes.arrayOf(PropTypes.string),
          interpretations: PropTypes.string,
          tissues: PropTypes.arrayOf(PropTypes.string),
          tumour_types: PropTypes.arrayOf(PropTypes.string),
          disease_or_trait: PropTypes.node,
          pub_med_references: PropTypes.arrayOf(PropTypes.number),
          variants: PropTypes.arrayOf(
            PropTypes.shape({
              variants: PropTypes.arrayOf(PropTypes.string),
              type: PropTypes.string,
              definition: PropTypes.string,
              gene_id: PropTypes.number,
            })
          ),
        })
      ),
    })
  ),
  card: PropTypes.instanceOf(Card).isRequired,
};

PMKBCard.defaultProps = {
  evidenceCount: 0,
  topEvidence: {},
  pmkbData: [],
};

const mapStateToProps = (state) => ({
  evidenceCount: getEvidenceCountPMKB(state),
  topEvidence: gettopEvidencePMKB(state),
  pmkbData: getWeillCornell(state),
});

export default connect(mapStateToProps)(PMKBCard);
